import { render, staticRenderFns } from "./Empresa.vue?vue&type=template&id=5b7fd752"
import script from "./Empresa.vue?vue&type=script&lang=ts"
export * from "./Empresa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports